import styled from "styled-components";

const SkillsWrapper = styled.div`
    padding-bottom: 2%;
    display: flex;
    flex-direction: row;
    justify-content: left;
    column-gap: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
`;

const SkillsUnitWrapper = styled.div`
    border: 1px solid;
    border-radius: 10px;
    padding: 2px;
`;

export { SkillsWrapper, SkillsUnitWrapper };
